import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { translate } from '../../locales';
import './style.css';

const StaffPage: React.FC = () => {
  const { language } = useLanguage();
  const t = (key: any) => translate(key, language as 'en' | 'ua');

  return (
    <div className="staff-page">
      <h1>{t('pages.staff.title')}</h1>
      <p>{t('pages.staff.description')}</p>
      {/* TODO: Implement staff management */}
    </div>
  );
};

export default StaffPage;
